import React from "react";
import { useScroll } from "../context/UseContextScroll";
import { SvgIcon } from "../pages/Home/styled";

function Icon() {
  const { scroll } = useScroll();

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="38"
      fill="none"
      viewBox="0 0 39 38"
      openIcon="true"
      scroll={scroll}
    >
      <path
        fill="#A71B38"
        d="M37.14 10.36a.821.821 0 00-.87.87V28.5a.811.811 0 01-.86.86h-2.14a.87.87 0 000 1.73h2.14A2.54 2.54 0 0038 28.5V11.23a.819.819 0 00-.86-.87zM5.18 4.32a.87.87 0 11-1.73-.186.87.87 0 011.73.186zM7.77 4.32a.86.86 0 11-.86-.87.85.85 0 01.86.87zM10.36 4.32a.86.86 0 11-.86-.87.85.85 0 01.86.87zM33.68 3.45H13a.82.82 0 00-.86.87.808.808 0 00.86.86h20.68a.82.82 0 00.87-.86.82.82 0 00-.87-.87z"
      ></path>
      <path
        fill="#A71B38"
        d="M35.41 0H2.59A2.54 2.54 0 000 2.59V28.5a2.54 2.54 0 002.59 2.59h2.14a.87.87 0 000-1.73H2.59a.811.811 0 01-.86-.86V2.59a.81.81 0 01.86-.86h32.82a.81.81 0 01.86.86v4.32H4.32a.82.82 0 00-.87.86.82.82 0 00.87.87h32.82a.82.82 0 00.86-.87V2.59A2.54 2.54 0 0035.41 0z"
      ></path>
      <path
        fill="#A71B38"
        d="M21.69 37.82c.78-.162 1.544-.396 2.28-.7h.26a13.344 13.344 0 002.06-1.1l.12-.07.12-.08c.684-.46 1.323-.981 1.91-1.56l.07-.07a13.48 13.48 0 10-23-9.52 13.37 13.37 0 004 9.52l.06.05a13.803 13.803 0 001.9 1.56l.11.06.14.09c.654.392 1.34.727 2.05 1h.26a14.12 14.12 0 002.28.7h.11c1.677.335 3.404.335 5.08 0h.11l.08.12zm-11.85-6l-.33-.46a11.54 11.54 0 01-2.22-6.8 11.71 11.71 0 1123.42 0 11.6 11.6 0 01-2.21 6.8l-.34.46-.29-.49A10.33 10.33 0 0023 27.09l-.53-.23.43-.38a5.86 5.86 0 002-4.4 5.93 5.93 0 10-9.86 4.39l.43.39-.53.23a10.33 10.33 0 00-4.84 4.28l-.26.45zM19 26.23a4.16 4.16 0 11-.02-8.32 4.16 4.16 0 01.02 8.32zm0 10a12 12 0 01-5.47-1.3l-.2-.1-.53-.3A8.534 8.534 0 0112 34v-.1c-.22-.16-.43-.34-.6-.49l-.21-.18.12-.26a8.5 8.5 0 0115.45 0l.11.26-.21.18c-.17.15-.37.32-.6.49L26 34a8.782 8.782 0 01-.77.54l-.53.3-.2.1a12 12 0 01-5.5 1.25v.04z"
      ></path>
    </SvgIcon>
  );
}

export default Icon;
